import { SearchTarget } from "../enums/SearchTarget";
import { SearchBy } from "../enums/SearchBy";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DQOIItem } from "./DQOIItem";


export class DQOISearchEvent extends BaseBus
{
    constructor(data: DQOISearchEvent = null) {
        super(data);
        if (data !== null) {
            this.dqoiItem = new DQOIItem(data.dqoiItem)
        }
    }
    CID() : any {
        return this.id;
    }
    searchTarget: SearchTarget;
    id: any;
    dispatchId: any; // GUID;
    quoteNumber: string;
    invoiceNumber: string;
    poNumber: string;
    woNumber: string;
    orderNumber: string;
    searchBy: SearchBy = SearchBy.any;
    isNew: boolean = false;
    isConstruction: boolean ;
    dqoiItem: DQOIItem;

    get hasDispatchId(): boolean {
        return CommonFunctions.hasValue(this.dispatchId);
    }

    loadFromQueryString(params: any): void {
        for (let key in params) {
            if (params[key]) {
                if (key === "searchTarget") {
                    this[key] = parseInt(params[key]);
                }
                else if (key === "searchBy") {
                    this[key] = parseInt(params[key]);
                }
                else if (key === "isNew" || key === "isConstruction") {
                    this[key] = !!params[key];
                }
                else {
                    this[key] = params[key];
                }
            }
        }
    }

    clear() {
        this.dispatchId = "";
        this.quoteNumber = "";
        this.invoiceNumber = "";
        this.poNumber = "";
        this.woNumber = "";
        this.orderNumber = "";
        this.searchBy = SearchBy.any;
    }
    getQueryStringParams(): {} {
        const params = {};
        if (this.dispatchId) {
            params["dispatchId"] = this.dispatchId;
        }
        if (this.quoteNumber) {
            params["quoteNumber"] = this.quoteNumber;
        }
        if (this.invoiceNumber) {
            params["invoiceNumber"] = this.invoiceNumber;
        }
        if (this.poNumber) {
            params["poNumber"] = this.poNumber;
        }
        if (this.woNumber) {
            params["woNumber"] = this.woNumber;
        }
        if (this.orderNumber) {
            params["orderNumber"] = this.orderNumber;
        }
        if (this.searchBy) {
            params["searchBy"] = this.searchBy;
        }
        if (this.isNew) {
            params["isNew"] = this.isNew;
        }
        if (this.isConstruction) {
            params["isConstruction"] = this.isConstruction;
        }
        if (this.id) {
            params["id"] = this.id;
        }
        if (this.searchTarget) {
            params["searchTarget"] = this.searchTarget;
        }
        return params;
    }

    hasCriteriaSet(): boolean {
        return (this.dispatchId?.length > 0
            || this.quoteNumber?.length > 0
            || this.invoiceNumber?.length > 0
            || this.poNumber?.length > 0
            || this.woNumber?.length > 0
            || this.orderNumber?.length > 0
            || this.id?.length > 0
        );
    }
}
